import React from 'react'
import MediaQuery from 'react-responsive'

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';

const Projects = () => {
  return (
    <Box sx={{ padding: "20px 0px", marginLeft: '20px' }}>
        <MediaQuery maxWidth={576}>
        <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, fontSize: 18, color: '#797979' }}>
                Projects
            </Typography>
            <Box sx={{ marginTop: 3, display: 'flex', justifyContent: 'center',flexDirection:'column' }}>
                <Card sx={{  border: '1px solid #DFDFDF', borderRadius: '10px', marginRight: 2, marginBottom: 2 }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/odrs.JPG"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            Online Document Request System
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                            The system was made for residents of Brgy Landayan, Laguna. The technology stack used were ReactJS and Django REST Framework.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" href="https://github.com/ElectivesTeam/barangayrequestsystem" target= '_blank'>Repository</Button>
                        <Button size="small" href="https://landayan-odrs.herokuapp.com/" target= '_blank'>Live Demo</Button>
                    </CardActions>
                </Card>

                <Card sx={{ border: '1px solid #DFDFDF', borderRadius: '10px', marginRight: 2 , marginBottom: 2 }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/thesis.png"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            Social Distancing Analyzer
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                            Built using the YOLO v4 algorithm. The project has additional features like Top-Down View, Data Analytics, and a Web Controlled Camera.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" disabled>Repository is currently private</Button>
                        <Button size="small" href="https://www.youtube.com/watch?v=_foLrCXtPPc" target= '_blank'>Live Demo</Button>
                    </CardActions>
                </Card>

                <Card sx={{ border: '1px solid #DFDFDF', borderRadius: '10px', marginRight: 2, marginBottom: 2  }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/vote.png"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            PUP Vote
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                            Designed the user interface and handled front-end development for a paid side project.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" disabled>Repository is currently private</Button>
                    </CardActions>
                </Card>

                <Card sx={{  border: '1px solid #DFDFDF', borderRadius: '10px', marginRight: 2, marginBottom: 2  }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/aghim.JPG"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            AGHIM All-In-One Online Platform 
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                            Designed the user interface and handled full stack development for my internship at Lamina Studios. The web application is still in development.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" href="https://github.com/contrerasjake/AGHIM-Web" target= '_blank'>Repository</Button>
                    </CardActions>
                </Card>

                <Card sx={{ border: '1px solid #DFDFDF', borderRadius: '10px' , marginRight: 2, marginBottom: 2 }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/3d.jpg"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            Nyctophobia: Devil Unleashed (3D Game)
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                            Created prototypes that will be used in the development of Nyctophobia: Bloodline DLC for my internship at Lamina Studios.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" href="https://github.com/millaresluis/Game-Development-3D-Project" target= '_blank'>Repository</Button>
                    </CardActions>
                </Card>

                <Card sx={{ border: '1px solid #DFDFDF', borderRadius: '10px', marginRight: 2  }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/2d.png"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            Lost Glory (2D Platformer Game)
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                        The game was developed for the 2019 PUP CpE Game Fest. The game also won a second-place award.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" disabled>Repository is currently private</Button>
                    </CardActions>
                </Card>
            </Box>

            <Box sx={{ marginTop: 3, display: 'flex', justifyContent: 'space-between' }}>
                
            </Box>
        </MediaQuery>

        <MediaQuery minWidth={576}>
            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, fontSize: 18, color: '#797979' }}>
                Projects
            </Typography>
            <Box sx={{ marginTop: 3, display: 'flex', justifyContent: 'center' }}>
                <Card sx={{ width: '50%', border: '1px solid #DFDFDF', borderRadius: '10px', marginRight: 2 }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/odrs.JPG"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            Online Document Request System
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                            The system was made for residents of Brgy Landayan, Laguna. The technology stack used were ReactJS and Django REST Framework.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" href="https://github.com/ElectivesTeam/barangayrequestsystem" target= '_blank'>Repository</Button>
                        <Button size="small" href="https://landayan-odrs.herokuapp.com/" target= '_blank'>Live Demo</Button>
                    </CardActions>
                </Card>

                <Card sx={{ width: '50%', border: '1px solid #DFDFDF', borderRadius: '10px', marginRight: 2 }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/thesis.png"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            Social Distancing Analyzer
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                            Built using the YOLO v4 algorithm. The project has additional features like Top-Down View, Data Analytics, and a Web Controlled Camera.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" disabled>Repository is currently private</Button>
                        <Button size="small" href="https://www.youtube.com/watch?v=_foLrCXtPPc" target= '_blank'>Live Demo</Button>
                    </CardActions>
                </Card>
            </Box>

            <Box sx={{ marginTop: 3, display: 'flex', justifyContent: 'center' }}>
                <Card sx={{width: '50%', border: '1px solid #DFDFDF', borderRadius: '10px', marginRight: 2 }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/vote.png"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            PUP Vote
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                            Designed the user interface and handled front-end development for a paid side project.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" disabled>Repository is currently private</Button>
                    </CardActions>
                </Card>

                <Card sx={{ width: '50%', border: '1px solid #DFDFDF', borderRadius: '10px', marginRight: 2 }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/aghim.JPG"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            AGHIM All-In-One Online Platform 
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                            Designed the user interface and handled full stack development for my internship at Lamina Studios. The web application is still in development.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" href="https://github.com/contrerasjake/AGHIM-Web" target= '_blank'>Repository</Button>
                    </CardActions>
                </Card>
            </Box>

            <Box sx={{ marginTop: 3, display: 'flex', justifyContent: 'space-between' }}>
                <Card sx={{ width: '50%', border: '1px solid #DFDFDF', borderRadius: '10px' , marginRight: 2 }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/3d.jpg"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            Nyctophobia: Devil Unleashed (3D Game)
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                            Created prototypes that will be used in the development of Nyctophobia: Bloodline DLC for my internship at Lamina Studios.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" href="https://github.com/millaresluis/Game-Development-3D-Project" target= '_blank'>Repository</Button>
                    </CardActions>
                </Card>

                <Card sx={{ width: '50%', border: '1px solid #DFDFDF', borderRadius: '10px', marginRight: 2 }}>
                    <CardMedia
                        component="img"
                        height="190"
                        image="../img/2d.png"
                        alt=" "
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div" sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 16 }}>
                            Lost Glory (2D Platformer Game)
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Merriweather', fontWeight: 400, fontSize: 14 }}>
                        The game was developed for the 2019 PUP CpE Game Fest. The game also won a second-place award.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small" disabled>Repository is currently private</Button>
                    </CardActions>
                </Card>
            </Box>
        </MediaQuery>
        
    </Box>
  )
}

export default Projects